const INDUSTRY_BENCHMARK_ROWS = [
  ['Software & SaaS', 'Performance', [85, 80, 76, 69, 60]],
  ['Software & SaaS', 'Efficiency', [82, 77, 72, 65, 56]],
  ['Software & SaaS', 'Sustainability', [79, 74, 69, 62, 54]],
  ['Financial Services & FinTech', 'Performance', [82, 77, 72, 65, 57]],
  ['Financial Services & FinTech', 'Efficiency', [79, 74, 69, 62, 54]],
  ['Financial Services & FinTech', 'Sustainability', [85, 80, 75, 68, 60]],
  ['E-commerce & Marketplaces', 'Performance', [81, 76, 71, 64, 55]],
  ['E-commerce & Marketplaces', 'Efficiency', [84, 79, 74, 67, 58]],
  ['E-commerce & Marketplaces', 'Sustainability', [76, 71, 66, 59, 51]],
  ['Gaming & Digital Entertainment', 'Performance', [85, 80, 75, 68, 59]],
  ['Gaming & Digital Entertainment', 'Efficiency', [81, 76, 71, 64, 55]],
  ['Gaming & Digital Entertainment', 'Sustainability', [75, 70, 65, 58, 50]],
  ['Telecommunications & Media', 'Performance', [80, 75, 70, 63, 55]],
  ['Telecommunications & Media', 'Efficiency', [78, 73, 68, 61, 53]],
  ['Telecommunications & Media', 'Sustainability', [84, 79, 74, 67, 59]],
  ['Healthcare & HealthTech', 'Performance', [79, 74, 69, 62, 54]],
  ['Healthcare & HealthTech', 'Efficiency', [76, 71, 66, 59, 51]],
  ['Healthcare & HealthTech', 'Sustainability', [85, 80, 75, 68, 60]],
  ['Manufacturing & Industry 4.0', 'Performance', [78, 73, 68, 61, 53]],
  ['Manufacturing & Industry 4.0', 'Efficiency', [80, 75, 70, 63, 55]],
  ['Manufacturing & Industry 4.0', 'Sustainability', [82, 77, 72, 65, 57]],
  ['Transportation & Logistics', 'Performance', [77, 72, 67, 60, 52]],
  ['Transportation & Logistics', 'Efficiency', [84, 79, 74, 67, 58]],
  ['Transportation & Logistics', 'Sustainability', [76, 71, 66, 59, 51]],
  ['Energy & Utilities', 'Performance', [76, 71, 66, 59, 51]],
  ['Energy & Utilities', 'Efficiency', [75, 70, 65, 58, 50]],
  ['Energy & Utilities', 'Sustainability', [84, 79, 74, 67, 59]],
  ['Professional Services & Consulting', 'Performance', [83, 78, 73, 66, 57]],
  ['Professional Services & Consulting', 'Efficiency', [85, 80, 75, 68, 59]],
  ['Professional Services & Consulting', 'Sustainability', [74, 69, 64, 57, 49]]
];

export const INDUSTRY_OPTIONS = Array.from(
  new Set(INDUSTRY_BENCHMARK_ROWS.map(([industry]) => industry))
).map(industry => ({
  value: industry,
  label: industry
}));

export const INDUSTRY_BENCHMARKS = INDUSTRY_BENCHMARK_ROWS.reduce(
  (acc, [industry, metric, thresholds]) => {
    if (!acc[industry]) {
      acc[industry] = {};
    }

    acc[industry][metric.toLowerCase()] = thresholds;
    return acc;
  },
  {}
);

export const normalizeIndustry = value => {
  const normalizedValue = String(value || '').trim();

  return INDUSTRY_OPTIONS.some(option => option.value === normalizedValue)
    ? normalizedValue
    : '';
};

export const getIndustryBenchmarkTier = (industry, metric, score) => {
  const normalizedIndustry = normalizeIndustry(industry);
  const metricKey = String(metric || '')
    .trim()
    .toLowerCase();
  const numericScore = Number(score);

  if (!normalizedIndustry || !metricKey || Number.isNaN(numericScore)) {
    return null;
  }

  const thresholds = INDUSTRY_BENCHMARKS?.[normalizedIndustry]?.[metricKey];

  if (!Array.isArray(thresholds) || thresholds.length === 0) {
    return null;
  }

  const matchedTierIndex = thresholds.findIndex(
    threshold => numericScore >= threshold
  );

  if (matchedTierIndex === -1) {
    return {
      tier: thresholds.length + 1,
      label: `#${thresholds.length + 1}`,
      threshold: thresholds[thresholds.length - 1],
      exceedsBenchmark: false
    };
  }

  return {
    tier: matchedTierIndex + 1,
    label: `#${matchedTierIndex + 1}`,
    threshold: thresholds[matchedTierIndex],
    exceedsBenchmark: true
  };
};
